import AbstractBinaryOperatorFormulaNode from "./AbstractBinaryOperatorFormulaNode.js";

/**
 * `multiplicationFormulaNode` is a concrete implementation of
 * `AbstractBinaryOperatorFormulaNode` representing a multiplication node.
 */
export default class MultiplicationFormulaNode extends AbstractBinaryOperatorFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitMultiplicationNode(this, additionalInformation);
	}

	getLabel() {
		return "×";
	}

	static getType() {
		return "MultiplicationNode";
	}

	static precedence() {
		return this.multiplicativeNodesPrecedence();
	}

	static build(builder, additionalInformation) {
		return builder.buildBinaryOperationNode(this, additionalInformation);
	}
}
